import { HCF } from "@macashipo/mlib"
import i18next from "i18next"

const HNotify = {
  currentToken: null,
  registedSW: false,
  registerSW: cbSuccess => {
    if ("serviceWorker" in window.navigator) {
      window.navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then(registration => {
          console.log("Service Worker đăng ký thành công:", registration)
          HNotify.registedSW = true
          if (cbSuccess) {
            cbSuccess()
          }
        })
        .catch(error => {
          console.log("Lỗi đăng ký Service Worker:", error)
        })
    }
  },
  initFirebaseMsg: () => {
    let _firebaseConfig = HCF.getCF("firebaseConfig")
    if (_firebaseConfig) {
      window._firebase_firebaseConfig = _firebaseConfig
      const script = document.createElement("script")
      script.type = "module"
      script.innerHTML = `
          import { initializeApp } from "https://www.gstatic.com/firebasejs/11.3.1/firebase-app.js";
          window._firebase_initializeApp = initializeApp;  
          if(window._firebase_initializeApp){
            window._firebase_app = window._firebase_initializeApp(window._firebase_firebaseConfig);
            console.log("firebase init firebase_app")
          }         
      `
      document.body.appendChild(script)
    }
    if (HCF.getCF("enableFirebaseWebPush") === true) {
      HNotify.registerSW(() => {
        let _firebaseConfig = HCF.getCF("firebaseConfig")
        if (_firebaseConfig && HCF.getCF("firebaseWebPushVapidKey")) {
          const script = document.createElement("script")
          script.type = "module"
          script.innerHTML = `
            import { getMessaging, getToken, onMessage } from "https://www.gstatic.com/firebasejs/11.3.1/firebase-messaging.js";
            window._firebase_getMessaging = getMessaging;
            window._firebase_getToken = getToken;
            console.log("firebase prepare init _firebase_messaging",window._firebase_app)
            if(window._firebase_app){
              window._firebase_messaging = getMessaging(window._firebase_app);
              console.log("firebase init _firebase_messaging")
            }             
          `
          document.body.appendChild(script)
        }
      })
    }
    if (HCF.getCF("enableAppCheck") === true) {
      let _appCheckKey = HCF.getCF("appCheckKey")
      if (_appCheckKey) {
        window._firebase_appcheckkey = _appCheckKey
        const script = document.createElement("script")
        script.type = "module"
        script.innerHTML = `
          import { initializeAppCheck, ReCaptchaV3Provider, getToken } from "https://www.gstatic.com/firebasejs/11.3.1/firebase-app-check.js";
          window._firebase_initializeAppCheck = initializeAppCheck;    
          console.log("firebase prepare init _firebase_appCheck",window._firebase_app)
          if(window._firebase_app){
            window._firebase_appCheck = initializeAppCheck(window._firebase_app, {
              provider: new ReCaptchaV3Provider(window._firebase_appcheckkey),
              isTokenAutoRefreshEnabled: true // Tự động làm mới token
            });
            window._firebase_appCheck_getToken = async ()=>{
              let _token = await getToken(window._firebase_appCheck, false);
              console.log("firebase appcheck token:",_token);
              return _token;
            }
          }     
        `
        document.body.appendChild(script)
      }
    }
  },
  requestPermission: async cbToken => {
    try {
      if (Notification.permission === "denied") {
        alert(
          i18next.t(
            "You have blocked notification permissions. Please go to your browser settings to enable them again."
          )
        )
      } else {
        const permission = await Notification.requestPermission()
        if (
          permission === "granted" &&
          window._firebase_getToken &&
          window._firebase_messaging
        ) {
          const vapidKey = HCF.getCF("firebaseWebPushVapidKey") //BFCfQeSYJYDZPXcfVO0nlslA29ig5Y7i2TaxVrFZhdf5LS-KsW3qWmc8ljvtS-yLIkNFCR_5s1rgvzlKTD0R_jg
          const token = await window._firebase_getToken(
            window._firebase_messaging,
            {
              vapidKey: vapidKey,
            }
          )
          console.log("FCM Token:", token)
          window._firebase_fcmtoken = token
          if (cbToken) {
            cbToken(token)
          }
        } else {
          console.log("Người dùng từ chối nhận thông báo.")
          if (cbToken) {
            cbToken(null, { msg: "Người dùng từ chối nhận thông báo." })
          }
        }
      }
    } catch (error) {
      console.error("Lỗi khi lấy token:", error)
      if (cbToken) {
        cbToken(null, { msg: "Lỗi khi lấy token." })
      }
    }
  },
}
window._HNotify = HNotify
export default HNotify
